export const TranslationColumns = {
  id: 1,
  ignore: 2,
  defaultLanguage: 3,
  localizedLanguage: 4
};

export const TranslationColumnWidths = {
  id: 25,
  ignore: 12,
  defaultLanguage: 60,
  localizedLanguage: 60
};
